import { Link } from "react-router-dom";
import { Button } from "./ui/button";
import { motion } from "framer-motion";
import isoLogo from "@/assets/isologo.png";
import gdprLogo from "@/assets/gdpr.png";
import soc2Logo from "@/assets/Soc2Type1certified.png";
import euaiLogo from "@/assets/euaiact.png";
import { useTranslation } from 'react-i18next';

const TrustIndicators = () => {
  const { t } = useTranslation();
  const badges = [
    { logo: isoLogo, label: "ISO 27001" },
    { logo: gdprLogo, label: "GDPR" },
    { logo: soc2Logo, label: "SOC 2" },
    { logo: euaiLogo, label: "EU AI Act" },
  ];

  return (
    <section className="py-16 relative z-10">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="flex flex-col md:flex-row items-center justify-between gap-8 p-8 rounded-2xl bg-card/30 backdrop-blur-sm border border-white/10"
        >
          <div className="flex items-center gap-6">
            <h3 className="text-2xl font-bold gradient-brand-text">
              {t('trust.title')}
            </h3>
            <div className="flex items-center gap-4">
              {badges.map((badge, index) => (
                <motion.div
                  key={badge.label}
                  initial={{ opacity: 0, scale: 0.8 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1, duration: 0.4 }}
                  className="flex flex-col items-center gap-1 p-3 rounded-xl bg-background/50 hover:bg-background/70 transition-all hover-lift"
                >
                  <img
                    src={badge.logo}
                    alt={badge.label}
                    className={badge.label === "SOC 2" ? "w-14 h-14 object-contain mb-1" : "w-10 h-10 object-contain mb-1"}
                  />
                  <span className="text-xs font-medium text-muted-foreground">{badge.label}</span>
                </motion.div>
              ))}
            </div>
          </div>
          
          <Link to="/compliance">
            <Button variant="outline" size="lg" className="hover-lift">
              {t('trust.cta')} →
            </Button>
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default TrustIndicators;
